import BookItem from "../common/bookItem";
export default class VisibleSwitchAnsStepAllGroupChild extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.ctrlOrder = 0;
        this.connectNumber = this.el.connectNumber;
    }

    init() {
        super.init();
        this.target.gotoAndStop(0);
    }

    trigger() {
    }
}